var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"decimal-number"},[_vm._v("\n  "+_vm._s(_vm.int)),_c('span',{staticClass:"decimal"},[_vm._v(_vm._s(_vm.decimal))])])}
var staticRenderFns = []

export { render, staticRenderFns }